import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SignIn() {
    let navigate = useNavigate();
    const [IsPending, setPending] = useState(false)
    const notify = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });

    const [initialValues, setInitialValues] = useState({
        "email": '',
        "password": '',
    })

    const validationSchema = yup.object({
        email: yup.string().
            required("Email is required.")
            .matches(
                /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
                "Please enter valid email address"
            ),
        password: yup.string()
            .min(8, "should be 8 chars minimum.")
            .required("Password is required."),
    })

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
    } = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            setPending(true);
            await axios.post(process.env.REACT_APP_BASE_URL + `login`, values, { headers: { "Access-Control-Allow-Origin": "*" } })
                .then((res) => {
                    localStorage.setItem('session_id', res.data.access_token);
                    setPending(false)
                    if (res.data.status === 200 && res.data.data.role.role === "admin") {
                        navigate('/home');
                    } else {
                        navigate(`/profile?session=${res.data.data._id}`);
                    }
                })
                .catch((error) => {
                    setPending(false)
                    if (error.response.status === 404) {
                        notify(error.response.data.message);
                    }
                })
        }
    })

    return (
        <>
            <ToastContainer />
            <div className="authentication">
                <div className="left-box">
                    <div className="form-box">
                        <div className="auth-head">
                            <h3>Hi, Welcome Back!</h3>
                            <p>Platform where user will able to keep their money.</p>
                        </div>
                        <form onSubmit={handleSubmit} autoComplete="Off" className="auth-form" method="POST">
                            <div className="form-group">
                                <label>Email or username</label>
                                <input
                                    type="text"
                                    className=""
                                    placeholder='Enter Email'
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                />
                                {errors.email && touched.email ? (
                                    <span className="required-lable">{errors.email} </span>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label>Password</label>
                                <input
                                    type="password"
                                    className=""
                                    placeholder='Password'
                                    name="password"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                />
                                {errors.password && touched.password ? (
                                    <span className="required-lable">{errors.password} </span>
                                ) : null}
                            </div>
                            {/* <p className="forget-link"><Link to="/reset-password">Forgot Password?</Link></p> */}
                            <button type="submit" className="form-submit" disabled={IsPending ? true : false}>{IsPending ? 'Loding...' : 'Sign In'}</button>
                            {/* <p className="form-link">Don't have an account?&nbsp;<Link to="/sign-up">Sign Up</Link></p> */}
                        </form>
                    </div>
                </div>
                <div className="right-box">
                    <img src="images/auth-signin.svg" alt="" />
                </div>
            </div>
        </>
    );
}

export default SignIn;